import { defineMessage } from 'react-intl'

export const middleDotSeparatorMessage = defineMessage({
  id: 'rwJJAbMcmh',
  defaultMessage: '·',
  description: 'Middle dot separator character used between items in lists and summaries',
})
